import React from "react";
import Card from "src/components/Cards/Basic";
import { Tab, Tabs } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DailyReportsPage from "../DailyReportsPage";
import MonthlyReportPage from "../MonthlyReportPage";

const LocalTaxDailyReportsPage = () => {
  const { t } = useTranslation("dashboard");
  const history = useHistory();
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const selectedTab = pathParts[pathParts.length - 1];
  const activeTab =
    selectedTab === "monthly-report" ? "monthly-report" : "daily-reports";

  function handleTabSelect(tab) {
    const basePath = ["daily-reports", "monthly-report"].includes(selectedTab)
      ? pathParts.slice(0, -1).join("/")
      : location.pathname;

    history.push(`${basePath}/${tab}`);
  }

  return (
    <Card title={t("local_tax_reports.title")}>
      <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
        <Tab
          title={t("local_tax_reports.tabs.daily_reports")}
          eventKey="daily-reports"
        >
          {activeTab === "daily-reports" && <DailyReportsPage />}
        </Tab>
        <Tab
          title={t("local_tax_reports.tabs.monthly_report")}
          eventKey="monthly-report"
        >
          {activeTab === "monthly-report" && <MonthlyReportPage />}
        </Tab>
      </Tabs>
    </Card>
  );
};

export default LocalTaxDailyReportsPage;
